export const symbols = {
    STAR: '★',
    ARROW: '➜'
}
